function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import { pluralize } from "../../utils";
import { maxBy } from "lodash";
import { SectionHeader } from "../../components";
var RubricGradingTable = function RubricGradingTable(_ref) {
  var assignment = _ref.assignment,
    submission = _ref.submission,
    onGraded = _ref.onGraded;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    rubricGrades = _useState2[0],
    setRubricGrades = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    studentScore = _useState4[0],
    setStudentScore = _useState4[1];
  var rubrics = assignment.rubrics;
  var maxMark = rubrics.reduce(function (sum, item) {
    return sum + maxBy(item.columns, 'point').point;
  }, 0);
  var isCellSelected = function isCellSelected(assignmentObjectiveId, cellId) {
    var row = rubricGrades.find(function (item) {
      return item.ms_teams_assignment_objective_id === assignmentObjectiveId;
    });
    if (!row) return false;
    return row.mst_rubric_cell_id === cellId;
  };
  var handleSelect = function handleSelect(assignmentObjectiveId, cellId) {
    setRubricGrades(function (prev) {
      var result = _toConsumableArray(prev);

      // Get current selected for the learning objective
      var rowIndex = result.findIndex(function (item) {
        return item.ms_teams_assignment_objective_id === assignmentObjectiveId;
      });
      if (rowIndex !== -1) {
        // something is currently selected, replace the cell id
        result[rowIndex] = _objectSpread(_objectSpread({}, result[rowIndex]), {}, {
          mst_rubric_cell_id: cellId
        });
      } else {
        result.push({
          ms_teams_assignment_objective_id: assignmentObjectiveId,
          mst_rubric_cell_id: cellId
        });
      }
      onGraded(result);
      return result;
    });
  };
  useEffect(function () {
    setRubricGrades(submission.rubric_grades);
  }, [submission]);
  useEffect(function () {
    var totalStudentScore = 0;
    rubricGrades.forEach(function (rubricGrade) {
      var rubric = assignment.rubrics.find(function (r) {
        return r.id === rubricGrade.ms_teams_assignment_objective_id;
      });
      var score = rubric.columns.find(function (c) {
        return c.cell_id === rubricGrade.mst_rubric_cell_id;
      }).point;
      totalStudentScore += score;
    });
    setStudentScore(totalStudentScore);
  }, [rubricGrades]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "table-responsive"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-bordered table-nurture-striped"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    style: {
      minWidth: '150px'
    }
  }, "Learning Outcome"), rubrics[0].columns.map(function (column) {
    return /*#__PURE__*/React.createElement("th", {
      style: {
        minWidth: '150px'
      },
      key: column.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center"
    }, /*#__PURE__*/React.createElement("span", null, column.name), /*#__PURE__*/React.createElement("span", {
      title: "".concat(column.point, " ").concat(pluralize('point', column.point)),
      className: "badge p-2 bg-nurture-navy-blue text-dark ms-2 text-white"
    }, column.point, " ", pluralize('point', column.point))));
  }))), /*#__PURE__*/React.createElement("tbody", null, rubrics.map(function (rubric) {
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, rubric['Learning Outcome']), rubric.columns.map(function (column) {
      return /*#__PURE__*/React.createElement("td", {
        className: "selectable ".concat(isCellSelected(rubric.id, column.cell_id) ? 'selected' : ''),
        onClick: function onClick() {
          return handleSelect(rubric.id, column.cell_id);
        }
      }, /*#__PURE__*/React.createElement("span", null, column.value), /*#__PURE__*/React.createElement("div", {
        className: "form-check"
      }, /*#__PURE__*/React.createElement("input", {
        className: "form-check-input cursor-pointer",
        type: "checkbox",
        value: "",
        checked: isCellSelected(rubric.id, column.cell_id)
      })));
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-md-flex alert alert-light justify-content-md-between align-items-center mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex me-4 align-items-center mt-2"
  }, /*#__PURE__*/React.createElement("h2", null, "\uD83D\uDC8E")), /*#__PURE__*/React.createElement(SectionHeader, {
    title: "Student Score",
    subtitle: "student assigned result for this assessment.",
    titleClassName: "fs-5"
  })), /*#__PURE__*/React.createElement("div", {
    className: "fw-3 mb-0 mt-3 mt-md-0",
    style: {
      minWidth: '14%'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "custom-badge badge-soft-info fs-5 rounded px-2 py-1 text-center",
    style: {
      width: '-webkit-fill-available'
    }
  }, /*#__PURE__*/React.createElement("b", null, studentScore), " out of ", /*#__PURE__*/React.createElement("b", null, maxMark)))));
};
RubricGradingTable.defaultProps = {};
export default RubricGradingTable;